import { render, staticRenderFns } from "./PlatesSubstitution.vue?vue&type=template&id=4208ca74&scoped=true"
import script from "./PlatesSubstitution.vue?vue&type=script&lang=js"
export * from "./PlatesSubstitution.vue?vue&type=script&lang=js"
import style0 from "./PlatesSubstitution.vue?vue&type=style&index=0&id=4208ca74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208ca74",
  null
  
)

export default component.exports